import { gql } from "@apollo/client"

export const CREATE_SCHOOL = gql`
  mutation createSchool($data: CreateSchoolRequest!) {
    school {
      create(data: $data)
    }
  }
`

export const UPDATE_SCHOOL = gql`
  mutation updateSchool($data: UpdateSchoolRequest!) {
    school {
      update(data: $data)
    }
  }
`

export const DELETE_SCHOOLS = gql`
  mutation deleteSchools($data: RemoveBatchSchoolRequest) {
    school {
      removeBatch(data: $data)
    }
  }
`
